import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import axios from 'axios';

const API_URL = process.env.REACT_APP_BACKEND_URL || '';

const ForgotPassword = () => {
  const [email, setEmail] = useState('');
  const [sent, setSent] = useState(false);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError('');
    try {
      await axios.post(`${API_URL}/api/admin/auth/forgot-password`, { email });
      setSent(true);
    } catch (err) {
      setError(err.response?.data?.detail || 'Something went wrong. Please try again.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen flex items-center justify-center bg-gray-100 px-4" data-testid="forgot-password-page">
      <div className="bg-white rounded-xl shadow-lg p-8 w-full max-w-md">
        <div className="text-center mb-8">
          <h1 className="text-2xl font-bold text-[#5c0701]">Forgot Password</h1>
          <p className="text-gray-500 mt-2 text-sm">Enter your email to receive a reset link</p>
        </div>

        {sent ? (
          <div data-testid="forgot-success">
            <div className="bg-green-50 border border-green-200 text-green-800 px-4 py-4 rounded-lg mb-6 text-sm">
              <p className="font-semibold mb-1">Check your email</p>
              <p>If an account with that email exists, we've sent a password reset link. Check your inbox and spam folder.</p>
            </div>
            <Link to="/admin/login" className="block text-center text-[#3a87fe] hover:underline text-sm font-medium" data-testid="back-to-login">
              Back to Login
            </Link>
          </div>
        ) : (
          <>
            {error && (
              <div className="bg-red-50 border border-red-200 text-red-700 px-4 py-3 rounded-lg mb-6 text-sm" data-testid="forgot-error">
                {error}
              </div>
            )}

            <form onSubmit={handleSubmit}>
              <div className="mb-6">
                <label className="block text-gray-700 font-medium mb-2 text-sm">Email Address</label>
                <input
                  type="email"
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-[#3a87fe] focus:border-transparent transition"
                  placeholder="admin@email.com"
                  required
                  data-testid="forgot-email"
                />
              </div>

              <button
                type="submit"
                disabled={loading}
                className={`w-full bg-[#5c0701] text-white py-3 rounded-lg font-semibold transition ${loading ? 'opacity-50 cursor-not-allowed' : 'hover:bg-[#7a1a0e]'}`}
                data-testid="forgot-submit"
              >
                {loading ? 'Sending...' : 'Send Reset Link'}
              </button>
            </form>

            <div className="mt-6 text-center">
              <Link to="/admin/login" className="text-sm text-[#3a87fe] hover:underline">
                Back to Login
              </Link>
            </div>
          </>
        )}
      </div>
    </div>
  );
};

export default ForgotPassword;
